// Module
var code = `<div class="position-info">
    <div class="position-info-label">
        <terceraLabel text="{{positionIdLabel}}" />
        <terceraLabel text="{{fPositionId}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{instrumentLabel}}" />
        <terceraLabel text="{{fInstrumentName}}" />
    </div>
    {{#if !hideRoute}}
    <div class="position-info-label">
        <terceraLabel text="{{routeLabel}}" />
        <terceraLabel text="{{fRoute}}" />
    </div>
    {{/if}}
    {{#.fLeverage}}
    <div class="position-info-label">
        <terceraLabel  text="{{.leverageLabel}}"/>  
        <terceraLabel  text="{{.fLeverage}}"/> 
    </div>
    {{/}}
        

    <div class="position-info-label">
        <terceraLabel text="{{sideLabel}}" />
        <terceraLabel text="{{fSide}}" additionalClass="{{sideColorClass}}" />
    </div>
    
    {{#if showProductType}}
    <div class="position-info-label">
        <terceraLabel text="{{productTypeLabel}}" />
        <terceraLabel text="{{fProductType}}" />
    </div>
    {{/if}}
    <div class="position-info-label">
        <terceraLabel text="{{amountLabel}}" />
        <terceraLabel text="{{fAmount}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{marketPriceLabel}}" />
        <terceraLabel text="{{fMarketPrice}}" additionalClass="{{sideColorClass}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{openPriceLabel}}" />
        <terceraLabel text="{{fOpenPrice}}" />
    </div>
    <div class="position-info-label">
        <terceraLabel text="{{dateTimeLabel}}" />
        <terceraLabel text="{{fDateTime}}" />
    </div>
        
    {{#partial labelTop}}
        {{this + (~/hideRoute ? 0 : 20)}}
    {{/partial}}

    {{#partial leverageTop}}
        {{this + (~/fLeverage ? 20 : 0)}}
    {{/partial}}

</div>

{{#partial labelProductTypeTop}}
    {{this + (showProductType ? (hideRoute ? 20 : 40) : (hideRoute ? 0 : 20)) + (fLeverage ? 20 : 0) }}
{{/partial}}`;
// Exports
export default code;